// React
import React, { useEffect, useState } from 'react';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// View
import { SellersCommissionPage } from './view';
import { useHistory } from 'react-router-dom';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const SellersCommission = () => {
  const [organizationStorage, setOrganizationStorage] = useState([]);

  const { organizations, sellers, getOrganizations, getSellers } =
    ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      sellerInput: {
        label: '',
        value: '',
      },
      comission: '',
      organizationInput: organizationStorage,
      instructions: '',
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string().required(),
      periodEnds: Yup.string().required(),
      sellerInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      comission: Yup.string(),
      organizationInput: Yup.array().nullable(),
      instructions: Yup.string(),
    }),

    onSubmit: (values) => {
      let organizationsArray = values.organizationInput?.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        seller_id: values.sellerInput.value || null,
        organization_except: organizationsArray || null,
        instructions: values.instructions || null,
        comission: values.comission || null,
      };

      toggleLoading();
      api
        .create('/reports/financial/sellers-commission', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Comissão de Corretores');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    let defaultValue = sessionStorage.getItem('organizationInput');
    setOrganizationStorage(JSON.parse(defaultValue));

    getOrganizations();
    getSellers();
  }, []);

  return (
    <SellersCommissionPage
      history={history}
      createData={createData}
      validation={validation}
      // Data
      sellers={sellers || []}
      organizations={organizations || []}
    />
  );
};
